module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "large-7 columns top"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._m(1), _vm._v(" "), (_vm.requestSent) ? _c('div', {
    staticClass: "panel-content"
  }, [_c('spinner')], 1) : _vm._e(), _vm._v(" "), (_vm.requestStatus === 200) ? _c('div', {
    staticClass: "panel-content"
  }, [_vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "large-4 columns large-centered"
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('button', {
    staticClass: "full-width",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Aller à l'accueil")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.requestStatus != 200) ? _c('div', {
    staticClass: "panel-content"
  }, [_vm._m(3), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "large-4 columns large-centered"
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('button', {
    staticClass: "full-width",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Aller à l'accueil")])])], 1)])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "large-5 columns"
  }, [_c('img', {
    attrs: {
      "src": "/static/imgs/28719-640-transp.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n                Confirmation de l'email\n                "), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-12 columns"
  }, [_c('h2', [_vm._v("Roule ma poule")]), _vm._v(" "), _c('div', [_vm._v("Votre adresse mail est validé")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-12 columns"
  }, [_c('h2', [_vm._v("oui, mais non")]), _vm._v(" "), _c('div', [_vm._v("la vérification de l'email n'a pas pu aboutir, merci de contactez un admin")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9aa22fb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/create-account/confirm-email.vue
// module id = 785
// module chunks = 0